"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const QuickLinks = dynamic(async () =>
  withValidation(quickLinksInputs, (await import("./QuickLinks")).QuickLinks, "QuickLinks")
);

export const quickLinksInputs = [
  {
    name: "groups",
    type: "list",
    required: true,
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "categories",
        type: "list",
        required: true,
        subFields: [
          {
            name: "title",
            type: "string",
          },
          {
            name: "links",
            type: "list",
            required: true,
            subFields: [
              {
                name: "label",
                type: "string",
                required: true,
              },
              {
                name: "href",
                type: "url",
                required: true,
              },
            ],
          },
        ],
        defaultValue: [],
      },
    ],
    defaultValue: [],
  },
] as const satisfies Inputs;

export const QuickLinksComponent: RegisteredComponent = {
  name: "QuickLinks",
  component: QuickLinks,
  inputs: quickLinksInputs,
};
